import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import type { CurrentUser } from '../../api/types/auth';
import ReservationStatsPage from './pages/ReservationStatsPage';

/** Legacy `ReservationStats/Index` — master-GSA / B2E only, same audience as the
 *  legacy sidebar guard. Grouped under "Raporlar" alongside the sales reports. */
const isVisible = (user: CurrentUser | null) => !!user?.isMasterGsa || user?.userType === 'B2E';

export const reservationStatsModule: ModuleDefinition = {
  routes: [{ path: 'reservation-stats', element: <ReservationStatsPage /> }],
  menuItems: [
    {
      label: 'Rezervasyon İstatistikleri',
      path: 'reservation-stats',
      icon: <QueryStatsOutlinedIcon />,
      group: 'Raporlar',
      groupIcon: <AssessmentOutlinedIcon />,
      isVisible,
    },
  ],
};
